import { ExtendedColor } from './extendedColor';

export * from './extendedColor';

export default ExtendedColor;
